import React from "react";
import { PermissionAwareEditorToolbar } from "./PermissionAwareEditorToolbar";
import { Project } from "@/types";
interface MultiPageEditorToolbarProps {
  project?: Project | null;
  onOpenPermissionMatrix?: () => void;
  onOpenProjectSettings?: () => void;
  onOpenSharing?: () => void;
  onToggleVersioning?: () => void;
  isVersioningOpen?: boolean;
  isVersioningMode?: boolean;
}

export const MultiPageEditorToolbar: React.FC<MultiPageEditorToolbarProps> = (
  props,
) => {
  return (
    <div
      style={{
        borderBottom: `1px solid hsl(var(--border))`,
        backgroundColor: `hsl(var(--background))`,
      }}
    >
      {/* Standard Editor Toolbar */}
      <PermissionAwareEditorToolbar {...props} />
    </div>
  );
};
